var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-view"},[_c('VSidebarLayoutHeading',_vm._b({},'VSidebarLayoutHeading',_vm.sidebar,false),[_vm._t("search")],2),_c('div',{staticClass:"table-view__table-wrapper",class:( _obj = {}, _obj['with-pagination'] = _vm.withPagination, _obj )},[_vm._t("table")],2),_vm._t("pagination"),_vm._t("extra")],2)}
var staticRenderFns = []

export { render, staticRenderFns }